import type { FaireProductEntity } from "../../entity_types/product";

export const p_drtm36ks59: FaireProductEntity = {
  token: "p_drtm36ks59",
  type: "product",
  name: "Mixed Bath Salts",
  brandName: "WhatCallsTheHeart",
  imageUrl:
    "https://cdn.faire.com/fastly/5874226a39aa5cb8970ead0c916cb9a455557672ff2676abb0e85b0d62882bdf.jpeg",
  priceDollars: 2.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/81257006d62aea98403ba75bbd9165bc70301fbd1739164bc1eb4befd4296c90.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
